// 快速问诊相关api
/* eslint-disable */
export default {
    basePath: process.env.VUE_APP_H5_CENTER,
    apiList: {
        // 快速问诊-获取问诊订单信息
        H5_INQUIRY_CENTER_GET_CACHE: "/openRemoteInquiry/order/getCache",
        // 快速问诊-提交申请
        H5_INQUIRY_CENTER_ORDER_COMMIT: "/openRemoteInquiry/order/commitInquiryOrder",
        // 快速问诊-获取问诊单状态
        H5_INQUIRY_CENTER_GET_ORDER_STATUS: "/openRemoteInquiry/order/getInquiryOrderStatus",
        // 快速问诊-获取IM登录信息
        H5_INQUIRY_CENTER_GET_IM_INFO: "/openRemoteInquiry/order/getImInfo",
        // 取消等待
        H5_INQUIRY_CENTER_CANCEL_WAIT: "/openRemoteInquiry/order/cancelWaiting",
        // 身份证认证
        H5_INQUIRY_CENTER_ID_CARD_VERI: "/openRemoteInquiry/person/idCardVerification"
    }
};
